import { Provider, Type } from '@angular/core';

import { CommunicationChannelStore } from '../../store/communication-channel/communication-channel.store';
import { CommunicationChannelApiService } from './communication-channel-api.service';

export function provideCommunicationChannels(apiImplementation: Type<CommunicationChannelApiService>): Provider[] {
  return [
    CommunicationChannelStore,
    {
      provide: CommunicationChannelApiService,
      useExisting: apiImplementation,
    },
  ];
}
